import React from "react"
import styled, { keyframes } from "styled-components"

const marqueeAnim = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`

const Wrapper = styled.div`overflow: hidden;`

const Marquee = styled.div`
  white-space: nowrap;
  position: relative;
  font-size: 0; /* Inline-block spacing issue hack */
  img {
    position: relative;
    animation: ${marqueeAnim} ${props => props.speed}ms infinite linear;
    display: inline-block;
    width: auto;
    height: 70px;
  }
`

const LogoMarquee = ({ src, speed }) => {
  return (
    <Wrapper>
      <Marquee speed={speed}>
        <img alt="logos" src={src} />
        <img alt="logos" src={src} />
      </Marquee>
    </Wrapper>
  )
}

LogoMarquee.defaultProps = {
  speed: 40000,
}

export default LogoMarquee



// WEBPACK FOOTER //
// ./src/components/LogoMarquee.js